import React from "react";
import { FormControl, InputLabel, FormHelperText, Box, Typography } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const RichTextEditor = ({
  label = "",
  value,
  onChange,
  placeholder,
  error = false,
  helperText = "",
  required = false,
  minHeight,
  width,
  title
}) => {
  const modules = {
    toolbar: [
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      // ["link", "image"],
      ["clean"],
    ],
  };

  const formats = [
    'bold', 'italic', 'underline',
    'list', 'bullet',
    // 'link', 'image'
  ];

  return (
    <FormControl fullWidth error={error}>
      {title && (
        <Typography sx={{
          fontWeight: 500,
          fontSize: 18,
          color: '#626478',
          marginBottom: '10px'
        }}>
          {title} {required && '*'}
        </Typography>
      )}

      <Box
        sx={{
          border: "1px solid",
          borderColor: error ? "#d32f2f" : "rgba(0, 0, 0, 0.23)",
          borderRadius: "4px",
          position: "relative",
          "&:hover": {
            borderColor: error ? "#d32f2f" : "#000",
          },
          "&:focus-within": {
            borderColor: error ? "#d32f2f" : "#1976d2",
            borderWidth: "2px",
            boxShadow: error
              ? "0 0 0 1px rgba(211, 47, 47, 0.2)"
              : "0 0 0 1px rgba(25, 118, 210, 0.2)",
          },

          "& .ql-toolbar": {
            backgroundColor: "#f8f9fa",
            border: "none",
            // borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
            borderTopLeftRadius: "4px",
            borderTopRightRadius: "4px",
            // padding: "8px 12px",
            margin: '16px 16px 0 16px',
            // minHeight: "44px",
            height: { xs: '76px', md: '50px' },
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
          },

          "& .ql-container": {
            border: "none",
            fontFamily: "inherit",
            fontSize: "14px",
            borderBottomLeftRadius: "4px",
            borderBottomRightRadius: "4px",
          },

          "& .ql-editor": {
            padding: " 8px 16px",
            minHeight: minHeight || "120px",
            width: width || "100%",
            lineHeight: "1.5",
            fontSize: "14px",
            color: "rgba(0, 0, 0, 0.87)",
            "&.ql-blank::before": {
              color: "rgba(0, 0, 0, 0.6)",
              fontStyle: "normal",
              left: "16px",
              right: "12px",
            },
            "&:focus": {
              outline: "none",
            }
          },

          // Toolbar button styling
          "& .ql-toolbar .ql-formats": {
            marginRight: "12px",
          },

          "& .ql-toolbar button": {
            padding: "4px",
            margin: "0 1px",
            borderRadius: "3px",
            "&:hover": {
              backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
            "&.ql-active": {
              backgroundColor: "rgba(25, 118, 210, 0.08)",
              color: "#1976d2",
            }
          },
        }}
      >
        {label && (
          <InputLabel
            shrink
            error={error}
            sx={{
              fontSize: '12px',
              position: 'absolute',
              top: '-8px',
              left: '16px',
              backgroundColor: 'white',
              padding: '0 4px',
              zIndex: 1,
            }}
          >
            {label}
          </InputLabel>
        )}

        <ReactQuill
          theme="snow"
          value={value || ""}
          onChange={onChange}
          modules={modules}
          formats={formats}
          placeholder={placeholder}
          style={{
            height: "auto",
          }}
        />
      </Box>

      {helperText && (
        <FormHelperText error={error} sx={{ mt: 0.5 }}>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default RichTextEditor;